<template>
  <div class="columns is-mobile">
    <div class="column">
      <b-notification type="is-info" aria-close-label="Close notification">
        <b>You are almost done!</b>
        <br />Please review the data you have entered before the final submission.
        <br />For your record, please print a copy of the claims submission report once you have submitted this claim.
      </b-notification>
      <b-message type="is-success" has-icon>
        <h3
          class="title"
          style="font-weight: normal; text-transform: none;color:#004771"
        >Claim Reporting Summary : {{fnoldata.id}}</h3>
      </b-message>
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">Basic Info</p>
        </header>
        <div class="card-content">
          <div class="content">
            <div class="columns is-mobile">
              <div class="column">
                <div class="columns">
                  <div class="column">
                    <b-field label="Policy Number" expanded>{{ fnoldata.policy.policyNumber}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="Covered State"
                      expanded
                    >{{typeListDescription(fnoldata.jurisdictionState, "StateType")}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="Submit without Policy?"
                      expanded
                    >{{formatYNBoolean(fnoldata.policy.npAgreement)}}</b-field>
                  </div>
                </div>

                <div class="columns">
                  <div class="column">
                    <b-field
                      label="Who are you?"
                      expanded
                    >{{ typeListDescription(fnoldata.preparer.title, "SubmitterType")}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="When did injury occur?"
                      expanded
                    >{{getDateFormatted(fnoldata.injury.dateOfInjury)}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="Time of injury/illness occured"
                    >{{formatTime(fnoldata.injury.timeOfInjury)}}</b-field>
                  </div>
                </div>
                <b-field label="First Name">{{fnoldata.preparer.fname}}</b-field>
                <b-field label="Last Name">{{fnoldata.preparer.lname}}</b-field>
                <b-field label="How do you want us to notify you?">{{fnoldata.preparer.notifyBy}}</b-field>
                <b-field label="Email">{{fnoldata.preparer.email}}</b-field>
                <b-field label="Phone">{{formatPhone(fnoldata.preparer.phone.work)}}</b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <!-- Employer -->
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">Employer</p>
        </header>
        <div class="card-content">
          <div class="content">
            <div class="columns is-mobile">
              <div class="column">
                <div class="columns">
                  <div class="column">
                    <b-field
                      label="Has employer been informed of alleged injury claim?"
                      expanded
                    >{{fnoldata.employer.empInformed}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="Date of Employer's Knowledge/Notice of Injury"
                      expanded
                    >{{getDateFormatted(fnoldata.injury.dateReportedToEmployer)}}</b-field>
                  </div>
                </div>
                <b-field label="Employer Name">{{fnoldata.employer.name}}</b-field>
                <b-field label="Mailing Address">{{fnoldata.employer.address.street}}</b-field>
                <div class="columns">
                  <div class="column">
                    <b-field label="City" expanded>{{fnoldata.employer.address.city}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="State"
                      expanded
                    >{{ typeListDescription(fnoldata.employer.address.state, "StateType")}}</b-field>
                  </div>
                  <div class="column">
                    <b-field label="Zip code">{{fnoldata.employer.address.zip}}</b-field>
                  </div>
                </div>

                <b-collapse :open="false" aria-id="differentaddress">
                  <b-field
                    label="Is injury accident location different than mailing address?"
                    expanded
                  >{{ fnoldata.injury.onEmployerPremises }}</b-field>
                  <br />
                  <div class="content" aria-controls="differentaddress">
                    <b-field
                      label="Location where Event or Exposure Occurred (Number,Street,City,Zip)"
                    >{{fnoldata.injury.locationEventOccured}}</b-field>
                  </div>
                </b-collapse>
                <br />
                <div class="columns">
                  <div class="column">
                    <b-field label="Phone" expanded>{{formatPhone(fnoldata.employer.phone.work)}}</b-field>
                  </div>
                  <div class="column">
                    <b-field label="Fax" expanded>{{formatPhone(fnoldata.employer.phone.fax)}}</b-field>
                  </div>
                </div>
                <b-field label="Employer contact name" expanded>{{fnoldata.employer.contactName}}</b-field>
                <b-field label="Email" expanded>{{fnoldata.employer.email}}</b-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Injured Worker -->
      <br />
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">Injured Worker</p>
        </header>
        <div class="card-content">
          <div class="content">
            <!-- Content for Injured Worker -->
            <div class="columns is-mobile">
              <div class="column">
                <div class="columns">
                  <div class="column">
                    <b-field label="First Name" expanded>{{fnoldata.employee.firstName}}</b-field>
                  </div>
                  <div class="column">
                    <b-field label="Last name" expanded>{{fnoldata.employee.lastName}}</b-field>
                  </div>
                  <div class="column">
                    <b-field label="Middle Init" expanded>{{fnoldata.employee.middleInitials}}</b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <b-field label="Social security #">{{formatSSN(fnoldata.employee.ssn)}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="Birth date"
                      expanded
                    >{{getDateFormatted(fnoldata.employee.dateOfBirth)}}</b-field>
                  </div>
                </div>
                <b-field label="Mailing address">{{fnoldata.employee.address.street}}</b-field>
                <div class="columns">
                  <div class="column">
                    <b-field label="City" expanded>{{fnoldata.employee.address.city}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="State"
                    >{{typeListDescription(fnoldata.employee.address.state,"StateType")}}</b-field>
                  </div>
                  <div class="column">
                    <b-field label="Zip code">{{fnoldata.employee.address.zip}}</b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                  <b-field label="Phone">{{formatPhone(fnoldata.employee.phone.mobile)}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="Gender"
                      expanded
                    >{{typeListDescription(fnoldata.employee.gender,"GenderType")}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="Date of hire"
                      expanded
                    >{{getDateFormatted(fnoldata.employment.dateOfHiring)}}</b-field>
                  </div>
                </div>
                <b-field label="Occupation" expanded>{{fnoldata.employment.occupation}}</b-field>
                <br />
                <b-field
                  label="Employment status"
                >{{typeListDescription(fnoldata.employment.employmentStatus, "EmpStatus")}}</b-field>
                <br />
                <div class="columns">
                  <div class="column">
                    <b-field label="Employee usual work hours">{{fnoldata.employment.hoursPerDay}}</b-field>
                  </div>
                  <div class="column">
                    <b-field label="Days per week" expanded>{{fnoldata.employment.daysPerWeek}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="Total weekly hours?"
                      expanded
                    >{{fnoldata.employment.totalWeeklyHours}}</b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <b-field
                      label="Gross wages/salary ($)"
                      expanded
                    >{{fnoldata.employment.grossWages}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="Pay Period"
                      expanded
                    >{{typeListDescription(fnoldata.employment.grossWagePer,"WagePaidType")}}</b-field>
                  </div>
                </div>
                <b-field
                  label="Other wages reported? (eg. Tips, meals, lodging, bonus..)"
                >{{fnoldata.employment.opy}}</b-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Injured Worker Details-->
      <br />
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">Injury Details</p>
        </header>
        <div class="card-content">
          <div class="content">
            <!-- Content for Injured Worker Details -->
            <div class="columns is-mobile">
              <div class="column">
                <b-field
                  label="How Injury/Illness Occurred; Describe Sequence ofEvents"
                >{{fnoldata.injury.claimInjuryDescription}}</b-field>
                <b-field
                  label="Other Workers Injured/Ill in this event?"
                  expanded
                >{{fnoldata.injury.rbOthInj}}</b-field>
                <b-field
                  label="Part of Body Affected"
                  expanded
                >{{typeListDescription(fnoldata.injury.bodyPart, "BodyPartType")}}</b-field>
                <b-field
                  label="Medical Diagnosis (If available)"
                >{{fnoldata.injury.medicalDiagnosis}}</b-field>

                <b-field
                  label="If employee died, date of death"
                  expanded
                >{{getDateFormatted(fnoldata.injury.dateofDeath)}}</b-field>
                <b-field
                  label="Unable to work atleast one full day after date of Injury?"
                >{{fnoldata.injury.rbOneDay}}</b-field>
                <div class="columns">
                  <div class="column">
                    <b-field
                      label="Date Last worked"
                      expanded
                    >{{getDateFormatted(fnoldata.injury.dateLastWeekWorked)}}</b-field>
                    <b-field
                      label="Date returned to work"
                      expanded
                    >{{getDateFormatted(fnoldata.injury.employeeReturnedToWork)}}</b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <b-field label="Still off work?" expanded>{{fnoldata.injury.rbInjoffWk}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label=" Paid Full Wages, For Day Of Injury, Or Last Day Worked?"
                      expanded
                    >{{fnoldata.injury.employeePaidInjuryDay}}</b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="Salary being continued?"
                      expanded
                    >{{fnoldata.injury.employeeSalaryContinuted}}</b-field>
                  </div>
                </div>

                <b-field
                  label="Injured worker treated in emergency room?"
                  slot="trigger"
                  aria-controls="hospitalizedarea"
                >{{fnoldata.hospital.emergency}}</b-field>
                <br />
                <div
                  class="card"
                  aria-controls="hospitalizedarea"
                  v-if="fnoldata.hospital.emergency ==='Yes'"
                >
                  <div class="card-header" aria-controls="hospitalizedarea">
                    <p class="card-header-title">Hospital Information</p>
                  </div>
                  <div class="card-content" aria-controls="hospitalizedarea">
                    <div class="content" aria-controls="hospitalizedarea">
                      <b-field label="Name">{{fnoldata.hospital.name}}</b-field>
                        <b-field
                          label="Hospitalized as an Inpatient?"
                          slot="trigger"
                          aria-controls="hospitalizedarea"
                        >{{fnoldata.injury.hospitaliz}}</b-field>
                      <b-field label="Phone">{{formatPhone(fnoldata.hospital.phone.work)}}</b-field>
                      <b-field label="Mailing Address">{{fnoldata.hospital.address.street}}</b-field>
                      <div class="columns">
                        <div class="column">
                          <b-field label="City" expanded>{{fnoldata.hospital.address.city}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="State"
                            expanded
                          >{{typeListDescription(fnoldata.hospital.address.state,"StateType")}}</b-field>
                        </div>
                        <div class="column">
                          <b-field label="Zip code">{{fnoldata.hospital.address.zip}}</b-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <br />

                <b-field
                  label="Did injured worker seek medical treatment?"
                >{{fnoldata.injury.seekMedicalTreatment}}</b-field>
                <br />
                <div
                  class="card"
                  aria-controls="medicaltreatmentarea"
                  v-if="fnoldata.injury.seekMedicalTreatment ==='Yes'"
                >
                  <div class="card-header" aria-controls="medicaltreatmentarea">
                    <p class="card-header-title">Physician/Clinic Information</p>
                  </div>
                  <div class="card-content" aria-controls="medicaltreatmentarea">
                    <div class="content" aria-controls="medicaltreatmentarea">
                      <b-field label="Name">{{fnoldata.physicianORClinic.name}}</b-field>
                      <b-field label="Phone">{{formatPhone(fnoldata.physicianORClinic.phone.work)}}</b-field>
                      <b-field label="Mailing Address">{{fnoldata.physicianORClinic.address.street}}</b-field>
                      <div class="columns">
                        <div class="column">
                          <b-field label="City" expanded>{{fnoldata.physicianORClinic.address.city}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="State"
                            expanded
                          >{{typeListDescription(fnoldata.physicianORClinic.address.state,"StateType")}}</b-field>
                        </div>
                        <div class="column">
                          <b-field label="Zip code">{{fnoldata.physicianORClinic.address.zip}}</b-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Closing columns and column -->
      <b-field
        label="Agreement"
        :type="{'is-danger': errors.has('webAgreement')}"
        :message="{'Please check this box to proceed' : errors.first('webAgreement')}"
      >
        <b-checkbox
          v-model="fnoldata.tosAgreement"
          name="webAgreement"
          v-validate="'required:true'"
        >
          I agree with Republic's Claims Reporting
          <a @click="isAgreement = true">Agreement</a>.
        </b-checkbox>
      </b-field>
      <b-modal :active.sync="isAgreement">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="title is-4">Report of Work Injury / WebSite</p>
          </header>
          <section class="modal-card-body">
            <br />
            <b>NOTICE: Republic Indemnity accepts telephonic and internet reporting of loss information from duly authorized representatives of its policyholders with the understanding that said information is factual and accurate. Claims information submitted will be verified for coverage. Furthermore, Republic Indemnity accepts the filing of the first notice of loss with the understanding that it is not an admission of liability nor is it a certification of any claim. Finally, any person who knowingly and with intent to injure, defraud, or deceive, files a claim containing false, incomplete, or misleading information, may be guilty of a crime and subject to civil and criminal penalties, including fines and imprisonment.</b>
            <br />
            <br />By clicking Submit, you verify the information being submitted is factual and accurate. Upon submission, the claim will be sent to our Claims Team for registration and claims office assignment. A Claims Representative will contact you regarding the submission of this claim. If you have any questions, please call (800) 821-4520. For your record, please print a copy of the claims submission report once you have submitted this claim.
            <br />
          </section>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import {
  PhoneFormatter,
  SSNFormatter,
  YNBooleanFormatter
} from "../utils/util";

import TypeLists from "../data/typelists";

export default {
  props: ["fnoldata"],
  data() {
    return {
      isAgreement: false,
      detaildBodyPartList: TypeLists.DetailedBodyPart,
      stateMap: TypeLists.StatesFiltered,
      genderType: TypeLists.GenderType,
      submitterType: TypeLists.SubmitterType,
      wagePaidType: TypeLists.WagesPaidType,
      employmentStatus: TypeLists.EmploymentStatus
    };
  },
  methods: {
    getDateFormatted: function(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY");
      }
    },
    getJsonToString: function(value) {
      if (value) {
        return JSON.stringify(value);
      }
    },
    formatSSN: function(value) {
      return SSNFormatter(value);
    },
    formatPhone: function(value) {
      return PhoneFormatter(value);
    },
    formatTime: function(value) {
      if (value) {
        return moment(String(value)).format("hh:mm A");
      }
      return value;
    },

    formatYNBoolean: function(value) {
      console.log(value);
      if (value) {
        return YNBooleanFormatter(value);
      } else {
        return value;
      }
    },

    typeListDescription: function(value, typelist) {
      var desc = null;
      if (typelist === "StateType") {
        return this.stateMap[value];
      } else if (typelist === "BodyPartType") {
        return this.detaildBodyPartList[value];
      } else if (typelist === "GenderType") {
        desc = this.genderType.find(o => o.code == value);
        if (desc) {
          return desc.name;
        } else {
          return "";
        }
      } else if (typelist === "WagePaidType") {
        desc = this.wagePaidType.find(o => o.code == value);
        if (desc) {
          return desc.name;
        } else {
          return "";
        }
      } else if (typelist === "SubmitterType") {
        desc = this.submitterType.find(o => o.code == value);
        if (desc) {
          return desc.name;
        } else {
          return "";
        }
      } else if (typelist === "EmpStatus") {
        console.log(typelist);
        desc = this.employmentStatus.find(o => o.code == value);
        console.log(desc);
        if (desc) {
          return desc.name;
        } else {
          return "";
        }
      } else {
        return;
      }
    }
  },
  computed: {
    fullName: function() {
      this.fnoldata.preparer.name =
        this.fnoldata.preparer.fname + " " + this.fnoldata.preparer.lname;
      return this.fnoldata.preparer.name;
    }
  }
};
</script>

